  window.promotionElements = [];
  var start = new Date();

  // debouce events
  function debouncer(func, wait = 500, immediate = true) {
      let timeout;
      return function () {
        let context = this,
          args = arguments;
        let later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

  function checkIfPromotionsAreInview() {
    const promotionElements = window.promotionElements;
    const visiblePromotions = [];
    promotionElements.forEach((item) => {
      if (elementIsVisibleInViewport(item) 
          && elementIsVisible(item)
          && !item.hasAttribute('data-tracked')
      ) {
        visiblePromotions.push(item)
        item.setAttribute('data-tracked',true)
      }
    })
    //console.log(visiblePromotions)
    trackPromotionImpressions(visiblePromotions)
  }

  function checkIfSearchResultsAreInview() {
    const searchElement = document.querySelectorAll('#fs-collection-products .product__grid__info');
    //console.log(searchElement)
    const visibleResults = [];
    searchElement.forEach((item) => {
      if (elementIsVisibleInViewport(item) 
          && elementIsVisible(item)
          && !item.hasAttribute('data-tracked')
      ) {
        visibleResults.push(item)
        item.setAttribute('data-tracked',true)
      }
    })
    //console.log('visible:',visibleResults)
    return visibleResults
  }

  // checks css visible
  function elementIsVisible(elem) {
    //console.log(elem)
    try {
    return !!(elem.checkVisibility({
      checkOpacity: true,     
      checkVisibilityCSS: true,
      contentVisibilityAuto: true
    }));
    }catch(error) {
      console.log('fallback:checkVisibility')
    }
    return true
  }

  // checks on page viewport
  function elementIsVisibleInViewport(elem,partiallyVisible = false) {
    //console.log(elem)
    const { top, left, bottom, right } = elem.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
      ? ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
          ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
      : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
  }

  function trackPromotionImpressions(promotionElements) {
    const promotions = Array.from(promotionElements).map((element) => ({
      promotion_id: element.getAttribute('data-promotion_id').replace(/<[^>]*>/g, '').replace(/[^0-9a-z]/gi, ''),
      promotion_name: element.getAttribute('data-promotion_name').replace(/<[^>]*>/g, '').replace(/[^0-9a-z]/gi, ''),
      promotion_creative: element.getAttribute('data-promotion_creative').replace(/<[^>]*>/g, '').replace(/[^0-9a-z]/gi, ''),
      promotion_position: window.siteGlobals.pageType+'-'+element.getAttribute('data-promotion_position').replace(/<[^>]*>/g, '').replace(/[^0-9a-z]/gi, ''),
      promotion_theme: window.Shopify?.theme?.name || ''
    }));

    if (promotions.length > 0) {
      
        window.ElevarDataLayer.push({ 
          event: "promotion_impression",  ecommerce: {
          promoView: {
            promotions: promotions
          }
        }});
      
    }
  }

  function trackPromotionClick(promotionData) {
    
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'promotion_click',
        ecommerce: {
          promoClick: {
            promotions: [promotionData]
          }
        }
      });
      window.setPromoClick(JSON.stringify(promotionData))
    
  }

  function attachPromotionListeners() {
    window.promotionElements.forEach((element) => {
      element.addEventListener('click', () => {
        const promotionData = {
          promotion_id: element.getAttribute('data-promotion_id').replace(/<[^>]*>/g, '').replace(/[^0-9a-z]/gi, ''),
          promotion_name: element.getAttribute('data-promotion_name').replace(/<[^>]*>/g, '').replace(/[^0-9a-z]/gi, ''),
          promotion_creative: element.getAttribute('data-promotion_creative').replace(/<[^>]*>/g, '').replace(/[^0-9a-z]/gi, ''),
          promotion_position: window.siteGlobals.pageType+'-'+element.getAttribute('data-promotion_position').replace(/<[^>]*>/g, '').replace(/[^0-9a-z]/gi, ''),
          promotion_theme: window.Shopify?.theme?.name || ''
        };

        debouncer(trackPromotionClick(promotionData),10);
      });
    });
  }

  


  
    function waitForElevarDataLayer(maxAttempts = 20, interval = 250) {
      return new Promise((resolve, reject) => {
        let attempts = 0;
    
        const checkElevar = () => {
          attempts++;
          if (typeof ElevarDataLayer !== 'undefined') {
            resolve();
          } else if (attempts >= maxAttempts) {
            reject(new Error('Elevar DataLayer not available after maximum attempts'));
          } else {
            setTimeout(checkElevar, interval);
          }
        };
    
        checkElevar();
      });
    }

    waitForElevarDataLayer()
      .then(() => {
        // Update your custom dataLayer here
        updateCustomDataLayer();
      })
      .catch((error) => {
        console.error('Failed to detect Elevar DataLayer:', error);
      });
  
    function updateCustomDataLayer() {
      var time = new Date() - start;
      // console.log('Elevar Loaded:', time)
      window.promotionElements = document.querySelectorAll('[data-promotion_id]');
      checkIfPromotionsAreInview();
      window.addEventListener('scroll', debouncer(checkIfPromotionsAreInview));
      attachPromotionListeners();
    }

    

  function handleSearchResultsClick(fsProd) {
    const userProperties = {};
    window.ElevarDataLayer.push({
          event: "dl_select_item",
          user_properties: userProperties,
          ecommerce: {
            actionField:{
              click: {
                actionField: { 
                  list: window.location.pathname
                 },
                products: convertFSProductToClick(fsProd),
              }
            }
          }
        })
  }

  function convertFSProductToClick (fsProd) {
    var items = [];  
    var result = document.querySelector('[pid="'+fsProd+'"]');
    if(result) {
      var titleElement = result.querySelector('.product__grid__title');
      var dataElement = result.querySelector('.product__grid__title__wrapper')
    
      items.push({
        id: titleElement.getAttribute('id').replace('product-','') || '',
        name: titleElement.textContent.trim() || '',
        brand: dataElement.getAttribute('data-vendor'),
        optionOne:dataElement.getAttribute('data-color'),
        optionTwo:"",
        optionThree:"",
        category: dataElement.getAttribute('data-product-type'),
        price: dataElement.getAttribute('data-price') || "0",
        compare_at_price: dataElement.getAttribute('data-compare-price') || "0",
        product_id: titleElement.getAttribute('id').replace('product-','') || '',
        position: dataElement.getAttribute('data-placement'),
      })
    }
    return items;
    
}


  function handleSearchResultsView(searchTerm, count) {
    // console.log("#### handleSearchResultsView ran ####");
    // console.log(searchTerm,count)
    if (typeof ElevarDataLayer !== 'undefined') {
      const userProperties = {};
      const items = checkIfSearchResultsAreInview();
      if(items.length) {
        let userProperties = {};
        window.ElevarDataLayer.push({
          event: "dl_view_search_results",
          user_properties: userProperties,
          ecommerce: {
            currencyCode: "USD",
            actionField: {
              "list":"search results:"+searchTerm
            },
          impressions: getSearchResultItems(items),
          }
        });
      }

    }
  }

  function getSearchResultItems(searchItems) {
    var items = [];
    var searchResults = searchItems;
    for (var i = 0; i < searchResults.length; i++) {
      var result = searchResults[i];
      //console.log(result)
      var titleElement = result.querySelector('.product__grid__title');
      var dataElement = result.querySelector('.product__grid__title__wrapper')
      items.push({
        id: titleElement.getAttribute('id').replace('product-','') || '',
        name: titleElement.textContent.trim() || '',
        brand: dataElement.getAttribute('data-vendor'),
        optionOne:dataElement.getAttribute('data-color'),
        optionTwo:"",
        optionThree:"",
        category: dataElement.getAttribute('data-product-type'),
        price: dataElement.getAttribute('data-price') || "0",
        compare_at_price: dataElement.getAttribute('data-compare-price') || "0",
        product_id: titleElement.getAttribute('id').replace('product-','') || '',
        position: dataElement.getAttribute('data-placement'),
      });
    }
    return items;
  }

  window.setPromoClick = function(pc) {
    localStorage.setItem("promoclick", pc);
    let promoclick = localStorage.getItem('promoclick');
    //console.log('set finding method:', findMethod.toString());
  }

  window.getPromoClick = function() {
    let promoclick = localStorage.getItem('promoclick') || [];
    //console.log('get finding method:', promoclick);
    let results = [];
    try {
      results = JSON.parse(promoclick)}
    catch(e) {

    }
   
    return results
  }

  window.resetPromoClick = function() {
    localStorage.removeItem('promoclick');
    let findMethod = localStorage.getItem('promoclick') || "";
  }

  // Finding methods (unchanged)
  window.setFindingMethod = function(fm) {
    localStorage.setItem("findingMethod", window.siteGlobals.pageType+'-'+fm);
    let findMethod = localStorage.getItem('findingMethod');
    //console.log('set finding method:', findMethod.toString());
  }
// Finding methods (unchanged)
  window.updateFindingMethod = function(fm) {
    if(window.getFindingMethod() === null || window.getFindingMethod() === "") {
      //console.log('quickview')
      window.setFindingMethod(fm)
    }
    //console.log('update finding method');
  }

  window.getFindingMethod = function() {
    let findMethod = localStorage.getItem('findingMethod') || "";
    //console.log('get finding method:', findMethod);
    return findMethod;
  }
  window.resetFindingMethod = function() {
    localStorage.removeItem('findingMethod');
    let findMethod = localStorage.getItem('findingMethod') || "";
    //console.log('reset finding method:', findMethod);
  }

  // Last Click Promotion methods (unchanged)
  window.setLastClickPromotion = function(promotion) {
    try {
      sessionStorage.setItem("lastClickPromotion", JSON.stringify(promotion));
      // console.log('last click promotion set:', promotion);
    } catch (e) {
      console.error('Error setting last click promotion:', e);
    }
  }
  window.getLastClickPromotion = function() {
    try {
      let storedPromotion = sessionStorage.getItem('lastClickPromotion');
      let promotion = storedPromotion ? JSON.parse(storedPromotion) : "";
      // console.log('last click promotion:', promotion);
      return promotion;
    } catch (e) {
      console.error('Error getting last click promotion:', e);
      return null;
    }
  }
  window.resetLastClickPromotion = function() {
    sessionStorage.removeItem('lastClickPromotion');
    // console.log('last click promotion reset');
    }

  // PDP view item (unchanged)
 window.setPDPProductTrackingDetails = function (pdetails) {
    window.productDetails = pdetails;
 }
 window.clearPDPProductTrackingDetails = function () {
    window.productDetails = [];
 }

  // Function to extract promotion data from element
  // to be removed
  function getPromotionData(element) {
    //console.log('getPromotionData')
    return {
      promotion_id: element.getAttribute('data-promotion_id') || '',
      promotion_name: element.getAttribute('data-promotion_name') || '',
      creative: element.getAttribute('data-promotion_creative') || '',
      position: element.getAttribute('data-promotion_position') || ''
    };
  }

  // Function to find the nearest promotion element
  function findNearestPromotionElement(element) {
    while (element && element !== document.body) {
      if (element.hasAttribute('data-promotion_id')) {
        return element;
      }
      element = element.parentElement;
    }
    return null;
  }

  // console.log('Promotion Tracking Loaded');
